var galleryThumbs = new Swiper('.main-product-eleven .thumbs .swiper-container', {
    spaceBetween: 10,
    slidesPerView: 'auto',
    height: 60,
    centerInsufficientSlides: true,
    loop: false,
});
const swiper = new Swiper('.main-product-eleven .product-images .swiper-container', {
    direction: 'horizontal',
    loop: false,
    slidesPerView: 1,
    spaceBetween: 0,
	navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
	},
    thumbs: {
      	swiper: galleryThumbs,
    },
});